import { Injectable } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ReportMarineService {
  constructor(private cacheService: CacheService, private http: HttpClient, private urlBuilder: UrlBuilderService) {}

  /**
   * Function to get the report transfer marine data from endpoint
   *
   * @param params params
   */
  public getMarineReport(params: any): Promise<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetLoopsReport`;
    return this.http.get(url, { params }).toPromise();
  }

  /**
   * Function to get report in Excel
   */
  public getMarineReportExcel(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetLoopsReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }
}
